import { render, staticRenderFns } from "./CarritoPage.vue?vue&type=template&id=53bc42a3&lang=pug&"
import script from "./CarritoPage.ts?vue&type=script&lang=ts&"
export * from "./CarritoPage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports